import { render } from "./DocumentPage.vue?vue&type=template&id=083d4208&lang=pug"
import script from "./DocumentPage.vue?vue&type=script&lang=ts"
export * from "./DocumentPage.vue?vue&type=script&lang=ts"
script.render = render

export default script